import { useMemo } from 'react'
import { useTranslation } from '../../useTranslation'
import Input from './input'

export interface RadioButtonsProps<T> {
    value: T
    onChange: (value: T) => void
    className?: string
    error?: { key: string; values: object }
    label?: string
    options: { label: string; id: T }[]
    hideLabel?: boolean
    horizontal?: boolean
}

export const useYesNoOptions = () => {
    const { t } = useTranslation()
    const options = useMemo(() => {
        return [
            { id: true, label: t('yes') },
            { id: false, label: t('no') },
        ]
    }, [t])

    return options
}

const RadioButtons = <T,>({ value, onChange, options, className, error, label, hideLabel, horizontal }: RadioButtonsProps<T>) => {
    return (
        <Input label={label ?? ''} error={error} hideLabel={hideLabel}>
            <div className={`flex justify-end ${className} gap-2 ${horizontal ? '' : 'flex-col'}`}>
                {options.map((option) => (
                    <label className="flex gap-3 cursor-pointer">
                        <input type="radio" name="testing" value="YES" checked={value === option.id} onChange={() => onChange(option.id)} />
                        <div>{option.label}</div>
                    </label>
                ))}
            </div>
        </Input>
    )
}

export default RadioButtons
